import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { EDITOR_Z_INDEX } from '../utils/defaults';

/**
 * Modales éditeur rendues dans document.body pour passer au-dessus
 * de la navbar, du menu de page et des composants empilés.
 */
export default function EditorModalPortal({
  open,
  children,
  zIndex = EDITOR_Z_INDEX.modal,
  className = 'fixed inset-0 flex items-center justify-center bg-black/50 p-4',
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className={className} style={{ zIndex }}>
      {children}
    </div>,
    document.body,
  );
}
